import classnames from 'classnames';
import React, { FC } from 'react';

import styles from './Checkbox.module.css';

import { Typography } from '@/shared/components/atoms/Typography';

import { ICheckboxProps } from './ICheckbox.d';

const Checkbox: FC<ICheckboxProps> = ({
  id,
  variant = 'primary',
  label,
  indeterminate,
  disabled,
  ...props
}) => {
  const labelClasses = classnames(styles['label'], {
    [styles['label-disabled']]: disabled,
  });

  const checkboxClasses = classnames(styles['checkbox'], {
    [styles['checkbox-primary']]: variant === 'primary',
    [styles['checkbox-success']]: variant === 'success',

    [styles['checkbox-primary-indeterminate']]:
      indeterminate && variant === 'primary',

    [styles['checkbox-indeterminate']]: indeterminate,
    [styles['checkbox-disabled']]: disabled,
  });
  return (
    <div className='flex items-center'>
      <input
        type='checkbox'
        id={id}
        className={checkboxClasses}
        disabled={disabled}
        {...props}
      />
      {label && (
        <label htmlFor={id} className={labelClasses}>
          <Typography variant='body1' weight='regular'>
            {label}{' '}
            {props?.required && <span className={styles['required']}>*</span>}
          </Typography>
        </label>
      )}
    </div>
  );
};

export { Checkbox };
